import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { environment } from '../../../../environments/environment';

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  if (isIssuerRequest(req.url)) {
    return next(req);
  }

  const { accessToken } = authService;
  return handleRabRequest(req, next, accessToken);
};

function isIssuerRequest(url: string) {
  return url.includes(environment.issuer);
}

function handleRabRequest(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
  accessToken: string,
) {
  const url = environment.apiUrl + request.url;

  const headers = request.headers
    .set('Access-Control-Allow-Origin', '*')
    .set('Access-Control-Allow-Credentials', 'true')
    .set('Content-Type', `application/json`)
    .set('x-api-key', environment.apiKey)
    .set('Authorization', `Bearer ${accessToken}`);

  return next(request.clone({ url, headers }));
}
